import React, { useEffect, useState } from 'react';
import "../../assets/styles/Search.css";
import Swal from "sweetalert2";
import iconSearch from "../../icons/icon-search.png";
import iconLock from "../../icons/icon-lock.png";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { config } from "../../config.js";
import { apiCheckAccount, apiGetSetting } from "../../services/api.service.js";
import post from "../../imgs/f8bet/post.png";
function SearchUser() {
  const [userName, setUserName] = useState("");
  const [validateUserName, SetValidateUserName] = useState("nhập tên tài khoản");
  const [domains, setDomains] = useState("");
  const [webSetting, setWebSetting] = useState("");
  const navigate = useNavigate();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await apiGetSetting();
        console.log("API Setting result:", result); // Add logging
        if (result && result.status_code === 200) {
          setWebSetting(result.data);
        }
      } catch (error) {
        console.error("fetchData error:", error);
        return Swal.fire({ icon: "error", text: "Lỗi kết nối, vui lòng liên hệ CSKH để được hỗ trợ." });
      }
    };
    fetchData();
  }, []);

  const checkUser = async (typeStep1=1) => {
    try {
      let finalUserName = userName;
      if (!userName) {
        const { value: inputName } = await Swal.fire({
          html: '<h2 style="color: #1F79FF; font-size: 24px; font-weight: 600; margin: 0;">Nhập tên tài khoản</h2>',
          input: 'text',
          inputLabel: 'Vui lòng nhập tên đăng nhập tài khoản để tiếp tục',
          inputPlaceholder: 'Vui lòng nhập tên đăng nhập tài khoản để tiếp tục',
          showCancelButton: true,
          confirmButtonText: 'Tiếp tục',
          cancelButtonText: 'Hủy',
          confirmButtonColor: '#1F79FF',
          padding: '1rem',
          inputValidator: (value) => {
            if (!value) {
              return 'Bạn không được để trống tên tài khoản!';
            }
          }
        });
        if (!inputName) {
          return; 
        }
        finalUserName = inputName.toLowerCase();
        setUserName(finalUserName)
      }
      
      // Ensure we have webSetting
      let currentWebSetting = webSetting;
      if (!currentWebSetting) {
        console.log("Fetching webSetting before navigation...");
        const settingResult = await apiGetSetting();
        if (settingResult?.status_code === 200 && settingResult.data) {
          currentWebSetting = settingResult.data;
          setWebSetting(currentWebSetting);
        } else {
          throw new Error("Could not fetch webSetting");
        }
      }

      let result = await apiCheckAccount(finalUserName);
      console.log("API Response in Search:", result);
      
      if (result && result.code === 200 && result.data) {
        console.log("Navigating with webSetting:", currentWebSetting);
        
        if (!currentWebSetting) {
          return Swal.fire({ 
            icon: "error", 
            text: "Không thể lấy thông tin cấu hình web. Vui lòng thử lại sau." 
          });
        }

        return navigate("/profile", {
          replace: true,
          state: {
            userName: finalUserName,
            data: result.data,
            webSetting: currentWebSetting,
            typeStep1: typeStep1,
          }
        });
      } else {
        console.error("Invalid API response:", result);
        Swal.fire({ 
          icon: "error", 
          text: result?.message || "Không thể xác thực tài khoản. Vui lòng thử lại." 
        });
      }
    } catch (error) {
      console.error("Error in checkUser:", error);
      Swal.fire({ 
        icon: "error", 
        text: "Đã xảy ra lỗi. Vui lòng thử lại sau." 
      });
    }
  };

  return (
    <div className="container">
      <div className="app">
        <Header isPageSearch={true} webSetting={webSetting}/>
        <div className="content">
          <div className="search-user">
            <span>VUI LÒNG XÁC NHẬN TÀI KHOẢN CỦA BẠN</span>
            <div className="input-search">
              {/* <img className="icon-search" alt="icon-search" src={iconSearch} /> */}
              <input className="input-account"
                onChange={(e) => setUserName(e.target.value.toLowerCase())}
                value={userName}
                type="text"
                placeholder="Nhập tên đăng nhập"
              />
              <button className="btn-search-account" onClick={() => checkUser("all")}>KIỂM TRA</button>
            </div>
            <span
              className="btn-get-pass"
              onClick={() => checkUser("pass")}
            >
              <img src={iconLock} alt="icon-bank"/>
              Quên mật khẩu
            </span>
            <div className="description" dangerouslySetInnerHTML={{ 
              __html: webSetting?.login_info_notice || 
              ``
            }} >
            </div>
          </div>
        </div>
      </div>
      <img src={post} alt="post" className="post-image" />
    </div>
  );
}

export default SearchUser;

